__turbopack_context__.v({
  "networkSpan": "index-module__ST31ja__networkSpan",
  "social": "index-module__ST31ja__social",
});
